import {AbstractEntity, AbstractEntityData} from './AbstractEntity';
import {CatalogTocEntity} from './CatalogTocEntity';

export interface CatalogCategoryEntityData extends AbstractEntityData {
  label: string;
  page: number;
  color: string;
  bgColor: string;
  items: CatalogTocEntity[];
}

export class CatalogCategoryEntity extends AbstractEntity<CatalogCategoryEntityData> {
  get label(): string {
    return this.data.label;
  }

  get page(): number {
    return this.data.page;
  }

  get color(): string {
    return this.data.color;
  }

  get bgColor(): string {
    return this.data.bgColor;
  }

  get items(): CatalogTocEntity[] {
    return this.data.items;
  }
}
